import Logo1 from  'assets/images/icon1.png';
import Logo3 from  'assets/images/icon3.png';
import Logo2 from  'assets/images/icon2.png';
import timeallocation from  'assets/images/timemanagement.png';
const FeatureData=[
    {
      "id": 1,
      "title": "Eisenhower Matrix For Prioritization",
      "description": "Prioritize tasks by importance and urgency using the Eisenhower Matrix for strategic task management. Address Urgent & Important tasks promptly while scheduling Important & Not Urgent ones strategically. Wisely delegate Not Important & Urgent tasks, and minimize or eliminate those Not Important & Not Urgent .Opt for a tailored prioritization approach when necessary.",
      "img_path": Logo1
    },
    {
      "id": 2,
      "title": "Visualize Time Allocation",
      "description": "Easily monitor daily activities through pie charts, visualizing time distribution for better insights. Identify key activities, streamline focus on crucial tasks, and plan effectively for the next day. This visual representation is vital in reducing and eliminating time spent on unnecessary and non-urgent tasks, as well as breaking unproductive habits like excessive social media use, optimizing overall productivity.",
      "img_path": timeallocation
    },
    {
      "id": 3,
      "title": "PA Evaluation Algorithm",
      "description": "Utilize the PA Evaluation Algorithm to visualize your personality attributes at the end of each performance cycle. Answer concise quiz questions designed to map your personality traits, providing a comprehensive view of your strengths and areas for development.A clear, concise snapshot of your personality attributes, aiding in personal growth and development.",
      "img_path": Logo2
    },
    {
      "id": 4,
      "title": "Heatmap Chart to track Consistency",
      "description": "Utilize the Heatmap Chart feature for meticulous consistency tracking, visualizing activity patterns. Color-coded and intuitive, it offers insights into workflow—recognizing peaks, lows, and sustained efforts. With reminders and calendar syncing, this tool ensures a proactive approach to task management, aiding in recognizing patterns and enhancing productivity.",
      "img_path": Logo3
    }
  ]
  

export default FeatureData;